import * as $ from 'jquery';
import 'bootstrap';

export class loginForm {

	private $loginError:Array<string> = [];

	loginFormSubmit(): any{
		let showClass:string = 'show-errors';

		$('.cug-login--form').click((evt:any) => {
			evt.preventDefault();
			let _self: any = this;
			let $CUGloginUsername : any = $('.login-username');
			let $CUGloginPassword : any = $('.login-password');
			let $CUGloginErrorDiv : any = $('.cuglogin-error--validation');
			let $CUGloginValidator: any = $('.cuglogin-validator');
			let $CUGvalidationSuccess    : any = true;
			_self.$loginError = [];

			$CUGloginErrorDiv.addClass(showClass);

				/** validate username */
				if($CUGloginUsername.val() == ''){
					let $loginMHNoValidate:any = $CUGloginUsername.attr('data-cugusername');
					_self.$loginError.push($loginMHNoValidate);
					$CUGloginUsername.addClass('has-error');
					$CUGloginUsername.parent().find('.booking-form--title').addClass('has-error');
					$CUGvalidationSuccess = false;
				} else{
					$CUGloginUsername.removeClass('has-error');
					$CUGloginUsername.parent().find('.booking-form--title').removeClass('has-error');
				}

				/** validate Login Password */
				if($CUGloginPassword.val() == ''){
					let $loginPasswordValidate:any = $CUGloginPassword.attr('data-cugpassword');
					_self.$loginError.push($loginPasswordValidate);
					$CUGloginPassword.addClass('has-error');
					$CUGloginPassword.parent().find('.booking-form--title').addClass('has-error');
					$CUGvalidationSuccess = false;
				} else{
					$CUGloginPassword.removeClass('has-error');
					$CUGloginPassword.parent().find('.booking-form--title').removeClass('has-error');
				}

				$CUGloginValidator.text(_self.$loginError.join(', '));

				if ($CUGvalidationSuccess) {
					$CUGloginErrorDiv.removeClass(showClass);
					document.cookie = "cug-login-page-path="+window.location.href +";path=/";
          var $data:any = {
          		userName: 		$CUGloginUsername.val(),
          		password: 		$CUGloginPassword.val(),
          		opCode: 			"Validate",
          		partnerName: 	$('#cugPartnerPageName').val()
          };

          // Use JQuery AJAX request to post data to a Sling Servlet
          $.ajax({
          	type: 'POST',
          	url:'/bin/services/new/cug',
          	data: $.param($data),
          	success: function(json:any){
          		console.log("##Successful: " + json);
          		if(json.success=="false") {
          			console.log("Error while submitting form" + json);
          			$CUGloginErrorDiv.addClass(showClass);
          			_self.$loginError.push($('.login-username').attr('data-cugusername'));
          			$CUGloginValidator.text(_self.$loginError.join(', '));
          		} else {
          			console.log("##Redirect URL: "+ json.url);
          			var responseUrl = json.url;
          			window.location.href = responseUrl;
          		}
          	},
          	error: function(error:any) {
          		console.log("Error while submitting form", error);
          		$CUGloginErrorDiv.addClass(showClass);
          		_self.$loginError.push('Error while submitting form.');
          		$CUGloginValidator.text(_self.$loginError.join(', '));
          	}
          });
				}
		});
	}

	hiddenFormSubmit():void {
		let hiddenCugForm:any = $('#hiddenCugLoginForm');
		if (hiddenCugForm.length) {
			var $data = {
				opCode: 			"Validate",
				partnerName:  $('#cugPartnerPageName').val()
			};

			$.ajax({
				type: 'POST',
				url:'/bin/services/new/cug',
				data: $.param($data),
				success: function(json:any){
					console.log("##Successful: " + json);
					console.log("##Redirect URL: "+ json.url);
					var responseUrl = json.url;
					window.location.href = responseUrl;
				},
				error: function(error:any) {
					console.log("Error while submitting hidden cug-login form" + error);
				}
			});
		}
	}

	cugLinks():void {
		$('#bookingNav').find('.login-nav').on('click', function () {
			$('#logged-in-user-menu').toggleClass('hidden');
		});

		$('#cugLogoutLink').on('click', function () {
			document.cookie = 'cug' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			var cugLoginPagePathCookieVal = document.cookie.match('(^|;)\\s*cug-login-page-path\\s*=\\s*([^;]+)');

			if (cugLoginPagePathCookieVal != null) {
				var cugLoginPagePath = cugLoginPagePathCookieVal ? cugLoginPagePathCookieVal.pop() : '';
				document.cookie = 'cug-login-page-path' + '=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
				window.location.replace(cugLoginPagePath);
			} else {
				location.reload();
			}
		});
	}
}


let scope:Element = document.querySelector('.cuglogin-component');
if (scope){
	try {
	let loginform = new loginForm();
	loginform.loginFormSubmit();
	$(document).ready(function(){
			loginform.hiddenFormSubmit();
			loginform.cugLinks();
	});
	} catch(e) {console.error(e);}
}
